import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const adminSupportSettingsPageStyles = StyleSheet.create({
	backButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		gap: 8,
		height: 'auto',
		background: 'transparent',
		border: 'none',
		cursor: 'pointer',
		fontSize: 14,
		color: THEME.colors.primary.main,
		padding: '8px 10px',
		marginBottom: 6,
		':hover': {
			color: THEME.colors.hover.main,
		},
	},
});
